import { api, ApiError } from "../core/api.js";
import { h, mount } from "../core/dom.js";
import { t } from "../core/i18n.js";

/**
 * Public profile (04-web §2.6, 01 §3.U). GET /v1/users/:handle.
 * Blocked/missing users are masked as 404 by the API; we render a graceful not-found state.
 */

interface PublicProfile {
  id: string;
  handle: string;
  display_name?: string;
  bio?: string | null;
  avatar_url?: string | null;
  stats?: { cuts?: number; variants?: number; followers?: number };
}

export async function profileView(params: Record<string, string>, root: HTMLElement): Promise<void> {
  const handle = params.handle ?? "";
  mount(root, h("div", { class: "center muted" }, t("profile.loading")));
  try {
    const p = await api.get<PublicProfile>(`/v1/users/${encodeURIComponent(handle)}`);
    const stats = p.stats ?? {};
    mount(
      root,
      h(
        "section",
        { style: "max-width:560px;margin:0 auto" },
        h(
          "div",
          { class: "card", style: "padding:20px" },
          h("h1", { style: "margin:0 0 6px" }, p.display_name ?? p.handle),
          h("p", { class: "muted", style: "margin:0" }, `@${p.handle}`),
          p.bio ? h("p", { style: "margin:12px 0 0" }, p.bio) : null,
          h(
            "div",
            { class: "muted", style: "display:flex;gap:16px;margin-top:16px;font-size:13px" },
            h("span", {}, t("profile.cuts", { n: stats.cuts ?? 0 })),
            h("span", {}, t("profile.variants", { n: stats.variants ?? 0 })),
            h("span", {}, t("profile.followers", { n: stats.followers ?? 0 })),
          ),
        ),
      ),
    );
  } catch (e) {
    if (e instanceof ApiError && e.status === 404) {
      mount(root, h("div", { class: "center muted" }, t("profile.notFound")));
      return;
    }
    const msg = e instanceof ApiError ? `${e.status} ${e.code}` : String(e);
    mount(root, h("div", { class: "center error" }, t("feed.loadFailed", { msg })));
  }
}
